/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_TicketsInputs */

const en_nav_tickets = /** @type {(inputs: Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

const ja_nav_tickets = /** @type {(inputs: Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チケット`)
};

const fr_nav_tickets = /** @type {(inputs: Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

const de_nav_tickets = /** @type {(inputs: Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets`)
};

/**
* | output |
* | --- |
* | "Tickets" |
*
* @param {Nav_TicketsInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_tickets = /** @type {((inputs?: Nav_TicketsInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_TicketsInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_tickets(inputs)
	if (locale === "ja") return ja_nav_tickets(inputs)
	if (locale === "fr") return fr_nav_tickets(inputs)
	return de_nav_tickets(inputs)
});